const baseRoute = 'corrective-actions/:moduleBridgeHex/';
export default {
  // user_module_correctiveActions_base: {
  //   path: baseRoute,
  //   parameters: {
  //     moduleBridgeHex: undefined,
  //   },
  // },
  user_module_correctiveActions_task_list: {
    path: `${baseRoute}task/list/:view/:page/:filtersHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      view: 'my-tasks',
      page: 1,
      filtersHex: 0,
    },
  },
  user_module_correctiveActions_task_add: {
    path: `${baseRoute}task/add/`,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  user_module_correctiveActions_task_edit: {
    path: `${baseRoute}task/edit/:taskID/:filtersHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      taskID: undefined,
      filtersHex: 0,
    },
  },
};
